import React from 'react';
import GroupLightComponent from './configs/LightGroupConfig';

const TerreoPagina = () => {
  return (
    <div className="terreo-container">
      <GroupLightComponent 
        
        groupIds={["grupo01", "grupo02", "grupo03","grupo04", "grupo05", "grupo06" , "grupo07","grupo09", "grupo19"]}

        
        pageTitle="" 
        pageId="2"
      />
    </div>
  );
};

export default TerreoPagina;